

<template>
  <div class="body">
    <div class="opage">
      <!-- 提货已确认 -->
      <baseBreadcrumb :page="$t('message.deliveryConfirm')" :menu="$t('message.returnAndExchangeLogistics')" />
      <div class="searchBox">
        <el-date-picker format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" type="datetimerange"
          range-separator="-" v-model="value" :default-time="['00:00:00', '23:59:59']"
          :start-placeholder="$t('message.startDate')" :end-placeholder="$t('message.dateClosed')">
        </el-date-picker>
        <div class="btns">
          <!-- 筛选 -->
          <el-button type="primary" @click="getData">{{
            $t("message.search")
          }}</el-button>
        <!-- 重置 -->
        <!-- <el-button size="small" @click="resetFilter">{{
                                            $t("message.reset")
                                          }}</el-button> -->
        </div>
      </div>
      <div style="padding: 0 20px">
        <el-table class="tableMy" :data="tableData" :header-cell-style="{ 'text-align': 'center', background: '#EDEFF4' }"
          :cell-style="{
            'text-align': 'center',
            background: '#f8f8f8',
          }">
          <el-table-column type="index" width="50" label="No">
          </el-table-column>
          <!-- 确认时间+ '暂无' -->
          <el-table-column property="created_at" :label="$t('message.acknowledgingTime')"></el-table-column>
          <!-- 收货时间 -->
          <el-table-column property="receive_at" :label="$t('message.goodsTime')"></el-table-column>
          <!-- 登记时间 -->
          <el-table-column property="created_at" :label="$t('message.registrationTime')"></el-table-column>

          <!-- 部门 -->
          <el-table-column property="created_at" :label="$t('message.department')">
            <template slot-scope="scope">
              {{ scope.row.admin[0].role[0].organization.name }}
            </template></el-table-column>
          <!-- 提出人 -->
          <el-table-column property="take_name" :label="$t('message.peoplePutForward')">
            <template slot-scope="scope">
              <div>
                <p>编号暂无</p>
                <p>{{ scope.row.created_by_name }}</p>
              </div>
            </template>
          </el-table-column>
          <!-- 签收员 -->
          <el-table-column property="receive_name" :label="$t('message.signForMember')">
            <template slot-scope="scope">
              <div>
                <p>编号暂无</p>
                <p>{{ scope.row.receive_name }}</p>
              </div>
            </template>
          </el-table-column>

          <!-- 收件人信息 -->
          <el-table-column property="receive_mobile" :label="$t('message.receive')">
            <template slot-scope="scope">
              <div>
                <p>{{ scope.row.receive_name }}</p>
                <p>{{ scope.row.receive_mobile }}</p>
              </div>
            </template>
          </el-table-column>
          <!-- 件数 -->
          <el-table-column property="num" :label="$t('message.jianShu')"></el-table-column>
          <!-- 运费.元 -->
          <el-table-column property="express_charge" :label="$t('message.RMBfreightCost')"></el-table-column>
          <!-- 提货联系人信息-->
          <el-table-column property="take_mobile" :label="$t('message.pickUpContactInformation')">
            <template slot-scope="scope">
              <div>
                <p>
                  {{ scope.row.take_name }}
                </p>
                <p>
                  {{ scope.row.take_mobile }}
                </p>
              </div>
            </template>
          </el-table-column>
          <!-- 地址、备注-->
          <el-table-column property="remark" :label="$t('message.AddressRemarks')"></el-table-column>
          <!-- 收货底单 -->
          <el-table-column property="receive_image" :label="$t('message.receivingEndOfaSingle')">
            <template slot-scope="scope">
              <div>
                <myImage :imgList="scope.row.receive_image" :showDel="false"></myImage>
              </div>
            </template>
          </el-table-column>
          <!-- 转账记录 -->
          <el-table-column property="transfer_image" :label="$t('message.transferRecord')">
            <template slot-scope="scope">
              <div>
                <myImage :imgList="scope.row.transfer_image" :showDel="false"></myImage>
              </div>
            </template>
          </el-table-column>

          <el-table-column property="transfer_image" :label="$t('message.transactionNumberLogisticsNumber')">
            <template slot-scope="scope">
              <div class="template order_no attribute">
                <p>
                  JY :<span class="JY">{{ scope.row.purchase_no }}</span>
                </p>
                <p v-for="(express, expressIndex) in scope.row
                  .order_purchase_express" :key="expressIndex">
                  WL: <span class="WL">{{ express.express_no }}</span>
                </p>
              </div>
            </template>
          </el-table-column>
          <!-- 操作 -->
          <el-table-column property="name" :label="$t('message.operation')">
            <template slot-scope="scope">
              <div class="btnGroup">
                <!-- 打印唛头 -->
                <el-button type="primary" @click="printingMarks(scope.row)">{{
                  $t("message.printingMarks")
                }}</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="allpag">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="form.page"
          :page-sizes="[10, 20, 30, 50]" :page-size="form.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
      <!-- 打印包裹信息 -->
      <div v-show="false">
        <PrintparcelinformationReceive ref="PrintparcelinformationReceive" :datas="printData" v-if="show">
        </PrintparcelinformationReceive>
      </div>

    </div>
  </div>
</template>
<script>
import myImage from "@/components/uploadFile/uploadFile.vue";
import PrintparcelinformationReceive from "@/components/Printedsheet/PrintparcelinformationReceive";
export default {
  data() {
    return {
      value: "",
      form: {
        status: 3,
      },
      total: 0,
      loading: null,
      tableData: [],
      diaTit: this.$t("message.offlinePickupRegistration"),
      individualPickupInformation: {}, //单个提货信息
      receiptForm: {}, //收货表单
      // 打印数据
      printData: {},
      show: false,
    };
  },
  components: {
    myImage,
    PrintparcelinformationReceive,
  },
  computed: {},
  mounted() {
    this.getData();
  },
  methods: {
    // 获取数据
    getData() {
      if (!this.value || this.value.length == 0) {
        this.form.start_time = null;
        this.form.end_time = null;
      } else {
        this.form.start_time = this.value[0];
        this.form.end_time = this.value[1];
      }
      this.$api.signInApi.receiveOfflineListConfirm(this.form).then((res) => {
        // console.log("事件名", res.data.data);
        if (res.code != 0) return this.$message.error(res.msg);
        // 接下来的操作
        this.tableData = res.data.data;
        this.$forceUpdate();
      });
    },
    resetFilter() {
      this.form = {};
      this.value = [];
    },
    handleAvatarSuccess(res, name, formName) {
      console.log("res", res);
      this.loading.close();
      this.receiptForm[name] = res.data;
      this.validateField("receiptForm", "receive_image", formName);
    },
    // 手动触发表单验证
    validateField(dataName, type, formRef) {
      if (this[dataName][type])
        this[dataName][type] = this[dataName][type].trim();
      this.$refs[formRef].validateField(type, (v) => {
        if (v == "") {
        } else {
        }
        this.$forceUpdate();
      });
    },
    beforeAvatarUpload(file) {
      const isJPG =
        ["image/jpeg", "image/png", "image/jpg"].indexOf(file.type) != -1;
      //console.log(file.type);
      if (!isJPG) {
        this.$message.error(this.$t("message.pleaseUploadPictures"));
        return isJPG;
      }
      this.loading = this.$loading({
        lock: true,
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.7)",
      });
    },
    // 添加线上提货
    tianJia() {
      this.individualPickupInformation = {};
      // 线下提货登记
      this.diaTit = this.$t("message.offlinePickupRegistration");
      this.$refs.dialog.open(
        "",
        () => {
          this.$api.signInApi
            .receiveOfflineStore(this.individualPickupInformation)
            .then((res) => {
              if (res.code != 0) return this.$message.error(res.msg);
              this.getData();
            });
        },
        () => { }
      );
    },

    // 打印
    printingMarks(row) {
      this.$api.signInApi.expressPackageInfo({ express_no: row.express_no }).then(res => {
        this.printData = res.data
        this.show = true
        this.$forceUpdate()
        this.$nextTick(() => {
          this.$print(this.$refs.PrintparcelinformationReceive);
        });
      })


    },

    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.form.pageSize = val;
      this.form.page = 1;
      this.getData();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.form.page = val;
      this.getData();
    },
  },
};
</script>
<style lang='scss' scoped>
.opage {
  background-color: #f8f8f8;
  height: 100%;
}

.searchBox {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  padding-left: 24px;
  margin-bottom: 15px;

  >* {
    flex: 0 0 180px;
    margin-right: 20px;
  }

  .el-date-editor {
    flex: 0 0 389px;
  }

  .btns {
    flex: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;

    .el-button {
      margin-left: 15px;
    }
  }
}

/deep/.tableMy {
  background-color: transparent;

  th {
    font-size: 14px;
    color: #333;
    font-weight: 400;
  }

  p {
    font-size: 14px;
    color: #333333;
    line-height: 20px;
  }

  .keHu {
    p {
      text-align: center;
    }
  }

  .dingDanZhiFuRuJin {
    p {
      text-align: left;
    }
  }

  .lianXiFangShi {
    color: #2c96e7;
    cursor: pointer;
  }

  .link {
    color: #fa5058;
  }

  .btnGroup {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    .el-button {
      display: flex;
      margin: 0 0 8px 0;
    }
  }
}

.baoGuoXinXi {
  background: #f8f8f8;
  border-radius: 0px 8px 8px 8px;
  padding: 24px 24px 1px;

  .el-select {
    width: 100%;
  }

  .imgUp {
    display: flex;
    align-items: flex-start;

    /deep/.avatar-uploader .el-upload {
      width: 80px;
      height: 80px;
      margin-right: 10px;
      border: 1px solid #e8e8e8;
      border-radius: 5px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
      background-color: white;
    }

    .avatar-uploader .el-upload:hover {
      border-color: #409eff;
    }

    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 80px;
      height: 80px;
      line-height: 80px;
      text-align: center;
    }

    /deep/.el-image {
      width: 80px !important;
      height: 80px !important;
    }

    /deep/.imgBox {
      height: 80px;
    }
  }

  textarea {
    width: 245px;
    height: 100px;
    background: #ffffff;
    border: 1px solid #edeff4;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 400;
    color: #333333;
    line-height: 20px;
    padding: 12px 16px;
  }
}

.allpag {
  width: 100%;
  display: flex;
  justify-content: center;
  margin: 25px 0;
}
</style>